/**
 * answer-edit-main.js
 */

import React from 'react';
import {
  Grid,
} from '@mui/material';
import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useRecordStore from 'contexts/record-store';
import { Types } from 'utils/constants';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import FormGridItem from 'components/menu-drawer/form-grid-item';
import Checkbox from 'components/form-inputs/checkbox';
import Select from 'components/form-inputs/select';
import TextField from 'components/form-inputs/text-field';
import Autocomplete from 'components/form-inputs/autocomplete';



export default function AnswerEditMain(props) {
  const {
    storedRecord,
    drawerState,
    translation,
    exerciseId,
    options,
    workMode,
  } = props;
  const { t } = useTranslation(translation);
  const recordStore = useRecordStore();
  const exerciseRecord = recordStore.useRecord(Types.Record.EXERCISE, exerciseId);
  const { control, setValue } = useFormContext();
  const wasPerformedValue = useWatch({ control, name: 'wasExercisePerformed' });
  const monitorValue = useWatch({ control, name: 'detection.monitor' });


  React.useEffect(() => {
    const exerMonitor = exerciseRecord.get().monitor;
    if (workMode === Types.WorkMode.DETECTION && !monitorValue && exerMonitor) {
      setValue('detection.monitor', exerMonitor);
    }

  // exerciseRecord getter can't be in
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monitorValue, workMode, setValue]);


  return (
    <>
      <EditorIconSection
        iconName='summary'
        iconMarginTop={6}
        helpProps={{
          translation,
          section: 'info'
        }}
      >
          {/* did perform */}
          <HelpTextItem
            sidebarText={drawerState.sidebarText}
            title={t('info.wasPerformed.helpTitle')}
            text={t('info.wasPerformed.helpInfo')}
          >
            {focusHandlers =>
              <>
                {/* checkbox */}
                <Checkbox
                  name='wasExercisePerformed'
                  label={`${storedRecord.dog.name} ${t('info.wasPerformed.labelPart')}`}
                />

                {/* not performed reason selector */}
                {!wasPerformedValue &&
                <Grid container spacing={2} style={{ marginTop: '8px', padding: '8px 0' }}>
                  <FormGridItem>
                    <Select
                      name='notPerformedReasonId'
                      label={t('info.notPerformedReasonId.label')}
                      options={options.notPerformed}
                      focusHandlers={focusHandlers}
                    />
                  </FormGridItem>
                </Grid>}

                {/* not performed explanation */}
                {!wasPerformedValue &&
                <TextField
                  name='notPerformedComments'
                  label={t('info.notPerformedComments.label')}
                  focusHandlers={focusHandlers}
                  multiline
                  rows={5}
                />}
              </>}
          </HelpTextItem>

          {wasPerformedValue && workMode === Types.WorkMode.DETECTION &&
          <>

            {/* blind - only shown for detection */}
            <HelpTextItem
              sidebarText={drawerState.sidebarText}
              title={t('info.blind.helpTitle')}
              text={t('info.blind.helpInfo')}
            >
              <Checkbox
                name='detection.blind'
                label={t('info.blind.label')}
              />
            </HelpTextItem>


            {/* monitor */}
            <HelpTextItem
              sidebarText={drawerState.sidebarText}
              title={t('info.monitor.helpTitle')}
              text={t('info.monitor.helpInfo')}
              // style={{ marginTop: 8 }}
            >
              {focusHandlers =>
                <Grid container spacing={2}>
                  <FormGridItem>
                    <Autocomplete
                      name={`detection.monitor`}
                      label={t('info.monitor.label')}
                      options={options.monitors.map(o => o.name)}
                      focusHandlers={focusHandlers}
                      defaultValue={storedRecord.detection.monitor || undefined}
                      rules={{
                        required: t('info.monitor.errMsgEmpty'),
                        validate: value => value.trim() !== '' || t('info.monitor.errMsgEmpty'),
                        maxLength: {
                          value: 100,
                          message: t('info.monitor.errMsgLength')
                        }
                      }}
                    />
                  </FormGridItem>
                </Grid>}
            </HelpTextItem>

          </>}

      </EditorIconSection>
    </>
  );
}